"use client"

import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check, Minus } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef<
    React.ComponentRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, checked, style, ...props }, ref) => {
    const isActive = checked === true || checked === 'indeterminate';

    return (
        <CheckboxPrimitive.Root
            ref={ref}
            data-slot="checkbox"
            checked={checked}
            className={cn(
                "peer h-[16px] w-[16px] shrink-0 rounded-[4px] border-[1.5px] border-border bg-card",
                "hover:border-accent",
                "data-[state=checked]:!bg-[#6a55d7] data-[state=checked]:!border-[#6a55d7] data-[state=checked]:!text-white",
                "data-[state=indeterminate]:!bg-[#6a55d7] data-[state=indeterminate]:!border-[#6a55d7] data-[state=indeterminate]:!text-white",
                "focus-visible:outline-none",
                "disabled:cursor-not-allowed disabled:opacity-55",
                "transition-all duration-[140ms]",
                className
            )}
            style={{
                ...style,
                // Inline styles as secondary mechanism (hardcoded hex, no CSS var issues)
                ...(isActive ? {
                    backgroundColor: '#6a55d7',
                    borderColor: '#6a55d7',
                    color: '#fff',
                } : {}),
            }}
            {...props}
        >
            <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
                <Check
                    className="h-[10px] w-[10px] [[data-state=indeterminate]_&]:hidden"
                    strokeWidth={2.5}
                />
                <Minus
                    className="hidden h-[10px] w-[10px] [[data-state=indeterminate]_&]:block"
                    strokeWidth={3}
                />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
